module.exports = __webpack_public_path__ + "static/media/payment.210490b3.svg";